import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';
import { Subject } from 'rxjs/Subject';

import * as _ from 'underscore';
import * as moment from 'moment';
import { PagerService } from 'services/index'

import { Router } from '@angular/router';

import { GlobalService } from 'services/global.service';
import { AuthService } from 'services/auth.service';

import { StudentDetailService } from '../student/studentdetail/studentdetail.service';

@Component({
    selector: 'app-student-modal-per-training',
    templateUrl: './student-modal-per-training.component.html',
    styleUrls: []
})

export class StudentModalPerTrainingComponent {
    // pass from previous component
    studentId: string;
    courseId: string;
    questionId: number;
    questionDay: string;
    questionData: any;
    isUnableToAnswer: boolean;
    questionNo: string;
    questionPosition;
    questionTotal;
    questions_data;
    //Next,Prevリンク用
    prev_question_item;
    next_question_item;
    //親へのイベント通知用
    @Output() clickPrevNextButton = new EventEmitter<any>();

    // declare in this component
    isChoose;
    questionImgUrl = "";
    feedbackImgUrl = "";
    feedbackText = "";
    feedbackText_under = "";
    Type3 = false;//非表示式

    // class helpers
    questionHelper = new this.globalService.enumHelpers.QuestionType();
    choiceAnswerHelper = new this.globalService.enumHelpers.ChoiceAnswerType();
    circleNumberHelper = new this.globalService.enumHelpers.CircleNumberType();

    isAdmin: Boolean = (this.authService.role == "admin") ? true : false;

    nowClickedLinkIndexNumber=0;
    resData_cache={};

    constructor(
        private authService: AuthService,
        public bsModalRef: BsModalRef,
        private http: Http,
        private location: Location,
        private router: Router,
        private pagerService: PagerService,
        private globalService: GlobalService,
        private studentDetailService: StudentDetailService,
    ) {

    }

    ngOnInit() {
        if (this.questions_data){
            this.changeQuestion(0);
        }
        
    }

    changeQuestion(index_number){

        this.nowClickedLinkIndexNumber = index_number;

        const question_item0 = this.questions_data.questions[index_number];
        // console.log(question_item0);
        this.questionDay = "Day" + question_item0.delivery_date;
        this.questionId = question_item0.question.id;
        this.questionNo = question_item0.question.no;
        // this.questionData = {};
        this.questionPosition = '';
        this.questionTotal = '';

        this.isUnableToAnswer=false;
        this.isChoose=false;
        this.questionImgUrl = "";
        this.feedbackImgUrl = "";
        this.feedbackText = "";
        this.feedbackText_under = "";
        this.Type3 = false;//非表示式

        this.getQuestionData();
    }

    getQuestionData(){
        const cacheName = '' + this.studentId + '_' + this.courseId + '_' + this.questionId + '';
        if (this.resData_cache[cacheName]){
            const resData = this.resData_cache[cacheName];
            this.questionData = resData.answer_history;
            this.questionPosition = resData.question_position;
            this.questionTotal = resData.question_total;
            //next,prevリンク出す用
            this.prev_question_item = this.getPrevModalQuestionData(resData);
            this.next_question_item = this.getNextModalQuestionData(resData);

            this.getQuestionF();
        }else{
            this.studentDetailService.getExplanationProblem(this.studentId, this.courseId, this.questionId)
                .then(resData => {
                    if(resData){ this.resData_cache[cacheName]=resData; }
                    //console.log(resData);
                    this.questionData = resData.answer_history;
                    this.questionPosition = resData.question_position;
                    this.questionTotal = resData.question_total;
                    //next,prevリンク出す用
                    this.prev_question_item = this.getPrevModalQuestionData(resData);
                    this.next_question_item = this.getNextModalQuestionData(resData);

                    this.getQuestionF();
                })
                .catch(err => console.log(err));
        }
    }

    getQuestionF(){
        this.feedbackText = this.globalService.getFooterPattern(this.questionData);
        this.feedbackText_under = this.globalService.getFooterPattern_under(this.questionData);
        this.setTypeLayout();
        if (this.questionData.question.question_image) {
            this.questionImgUrl = this.globalService.getImageUrl(this.questionData.question.question_image);
        }
        let answer_choice = this.globalService._setChoice(this.questionData);//回答したもの
        if (answer_choice > 0) {
            if (answer_choice == 1 && this.questionData.question.feedback_image) {
                this.feedbackImgUrl = this.globalService.getImageUrl(this.questionData.question.feedback_image);
            } else if (answer_choice == 2 && this.questionData.question.feedback_image2) {
                this.feedbackImgUrl = this.globalService.getImageUrl(this.questionData.question.feedback_image2);
            } else if (answer_choice == 3 && this.questionData.question.feedback_image3) {
                this.feedbackImgUrl = this.globalService.getImageUrl(this.questionData.question.feedback_image3);
            } else if (answer_choice == 4 && this.questionData.question.feedback_image4) {
                this.feedbackImgUrl = this.globalService.getImageUrl(this.questionData.question.feedback_image4);
            }
        } else {
            if (this.questionData.question.feedback_image) {
                this.feedbackImgUrl = this.globalService.getImageUrl(this.questionData.question.feedback_image);
            }
        }

        if (this.questionData.question.type == 3) {
            this.Type3 = true;
            this.isChoose = false;
            this.isUnableToAnswer = true;
        }
    }

    //モーダルで横移動するためのリンク先データを作る(Next)
    getNextModalQuestionData(resData) {
        var nowQid = resData.answer_history.question.id;
        var linkQid = null;

        //前後関係を探る
        for (var i = 0; i < resData.deliveries.length; i++) {
            if (resData.deliveries[i].question_id == nowQid) {
                if (resData.deliveries[i + 1] && resData.deliveries[i + 1].question_id) {
                    linkQid = resData.deliveries[i + 1].question_id;
                    break;
                }
            }
        }

        const returnItem = {
            delivery_date: '',//現状はいらないっぽい
            question: {
                id: linkQid,
                no: 0//現状はいらないっぽい
            }
        };
        //console.log(nowQid+' next:'+linkQid);
        return returnItem;
    }
    //モーダルで横移動するためのリンク先データを作る(Prev)
    getPrevModalQuestionData(resData) {
        var nowQid = resData.answer_history.question.id;
        var linkQid = null;

        //前後関係を探る
        for (var i = 0; i < resData.deliveries.length; i++) {
            if (resData.deliveries[i].question_id == nowQid) {
                if (resData.deliveries[i - 1] && resData.deliveries[i - 1].question_id) {
                    linkQid = resData.deliveries[i - 1].question_id;
                    break;
                }
            }
        }

        const returnItem = {
            delivery_date: '',//現状はいらないっぽい
            question: {
                id: linkQid,
                no: 0//現状はいらないっぽい
            }
        };
        //console.log(nowQid+' next:'+linkQid);
        return returnItem;
    }

    displayLinkText(data) {
        let text = '全文および解説を見る';
        let answerText = data.question[data.answer];

        return text;
    }

    displayLimitText(val) {
        let text = val ? val.replace(/\n/g, '') : "";
        if (text.length > 25) {
            text = text.substring(0, 25) + '...';
        }
        return text;
    }

    setTypeLayout() {
        this.isChoose = true;
        if (this.questionData.question.type === this.questionHelper.getValue('essay')) {
            this.isChoose = false;
        }
    }

    showHeaderTitle() {
        //let title = this.questionDay;
        const questionNumber = (parseInt(this.questionNo) <= 50) ? this.circleNumberHelper.getString(parseInt(this.questionNo)) : this.questionNo;

        let title = 'トレーニング' + this.questionData.question.question_group;
        // title += "（" + this.questionPosition + " / " + this.questionTotal + "）";

        return title;
    }

    displayCQLinkHead(answerObj){
        let headtext='';
        if (answerObj.answered_date){

            headtext='【回答済】';

        }
        if (answerObj.type==3){
            headtext = '【問題のみ】';
        }

        return headtext;
    }

    showTextLine() {
        let textLine = '【選択肢と回答】';

        if (!this.isChoose) {
            textLine = '【回答】';
        }

        return textLine;
    }

    showLabelCorrectOrFalse() {
        let text = '不正解です';

        if (this.questionData.result) {
            text = '正解です';
        }

        return text;
    }

    _onErrorImg(type) {
        if (type == 'footer') {
            this.feedbackImgUrl = '';
        } else if (type == 'header') {
            this.questionImgUrl = '';
        }
    }

    showChoicesOptions(choice) {
        let result;
        result = this.choiceAnswerHelper.getString(choice);

        return result;
    }

    showAnsweredDate(date) {
        return moment(date).format('YYYY/MM/DD HH:mm');
    }

    modalStudent(form: NgForm): void {
        console.log(form);
    }

    closeAndOpenModal(itemdata) {
        this.bsModalRef.hide();
        //親へイベントを通知
        this.clickPrevNextButton.emit({ data: itemdata });
    }



}


// WEBPACK FOOTER //
// ./src/app/component/customer/commentary-modal/student-modal-per-training.component.ts